export default __webpack_public_path__ + "static/media/image-27.f8f31a09.png";